<template>
  <div class="n-scroll-wrap" :style="{ width: width }">
    <div class="n-scroll-content" v-bind="$attrs">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { touch } from '../../utils/index';

export default {
  name: 'NScroll',
  props: {
    width: {
      type: String,
      default: '100%'
    }
  },
  mounted() {
    this.$nextTick(() => {
      touch(this.$el.querySelector('.n-scroll-content'), e => this.$emit(e));
    });
  }
};
</script>

<style lang="scss">
.n-scroll-wrap {
  width: 100%;
  height: 100%;
  max-height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  @media (max-width: 750px) {
    .n-scroll-content {
      width: 100% !important;
    }
  }
  .n-scroll-content {
    width: calc(100% + 17px);
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
  }
}
</style>
